import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { AvEmptyStateComponent } from '../../../../../Shared/Components/av-empty-state/av-empty-state.component';
import { TranslationService } from '../../../../../Shared/Services/translation.service';
import { COMMON_IMPORTS } from '../../../../../Shared/common-imports';
import {
  MONITORING_TOP_COLUMNS,
  MONITORING_TOP_LIMIT,
} from '../../../Consts/monitoring-top-table.const';
import { MonitoringTopRow } from '../../../Interfaces/monitoring-report.interface';
import { MonitoringTopDisplayRow } from '../../../Interfaces/monitoring-top-display-row.interface';
import { toTopDisplayRows } from '../../../Shared/monitoring-top-rows.util';
import { MonitoringRowLinkBuilder } from '../../../Types/monitoring-row-link-builder.type';

@Component({
  selector: 'app-monitoring-top-table',
  standalone: true,
  imports: [COMMON_IMPORTS, AvEmptyStateComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './monitoring-top-table.component.html',
  styleUrl: './monitoring-top-table.component.scss',
  host: { class: 'av-metric-card' },
})
export class MonitoringTopTableComponent<Row extends MonitoringTopRow = MonitoringTopRow> {
  readonly titleKey = input.required<string>();
  readonly hintKey = input.required<string>();
  readonly nameColumnKey = input.required<string>();
  readonly countColumnKey = input.required<string>();
  readonly emptyKey = input.required<string>();
  readonly rows = input.required<Row[]>();
  readonly rowLink = input<MonitoringRowLinkBuilder<Row> | null>(null);
  readonly linkLabelKey = input<string>('app.reports.monitoring.top.viewDemands');
  readonly progress = input<number>(1);

  protected readonly language = inject(TranslationService).currentLanguage;

  protected readonly displayedColumns = MONITORING_TOP_COLUMNS;

  protected readonly capacity = MONITORING_TOP_LIMIT;

  protected readonly displayRows = computed(() =>
    toTopDisplayRows(this.rows(), this.rowLink(), this.progress()),
  );

  trackRow(_index: number, row: MonitoringTopDisplayRow): string {
    return row.id;
  }
}
